import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = window.location.search;
    const isAuthCallback = params.includes('code=') && params.includes('state=');
    const isPostLogout = params.includes('postLogout=true');
    const isReauth = params.includes('reauth=1');

    if (req.url.includes(environment.auth0Domain)) {
      return next.handle(req);
    }

    if (isAuthCallback || isPostLogout || isReauth) {
      console.warn('[JwtInterceptor] auth transition in progress, request cancelled:', req.url);
      return EMPTY;
    }

    return this.auth.ensureValidAccessToken$().pipe(
      mergeMap(token => {
        if (!token) {
          console.warn('[JwtInterceptor] no token available, request cancelled');
          return EMPTY;
        }

        const tokenReq = req.clone({
          setHeaders: {Authorization: `${token}`}
        });

        return next.handle(tokenReq);
      }),
      catchError((err: HttpErrorResponse) => {
        console.error(
          '[JwtInterceptor] error for',
          req.method,
          req.url,
          '| status:',
          err?.status,
          '| error:',
          err?.error,
          '| message:',
          err?.message,
          '| full error:',
          err
        );

        // Only true auth failures (401 = invalid/expired token) trigger reauth.
        // 403 means "you ARE authenticated, but you cannot perform this specific
        // operation" — re-logging in won't change that, so logging the user out
        // would just be a confusing UX. Let the application surface a toast
        // instead. (UCSF-3042: previously any 403 from a per-AP mutating endpoint
        // would kick the user back to Auth0, which is wrong.)
        if (err?.status === 401) {
          console.warn('[JwtInterceptor] 401 detected, forcing reauth');
          this.auth.forceReauth(window.location.pathname);
          return EMPTY;
        }

        return throwError(() => err);
      })
    );
  }
}
